export const detect_side_rendering = () => {
    return typeof window === 'undefined' ? 'ssr' : 'csr';
}

export const has_ssr = () => detect_side_rendering() === "ssr"
